import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
// Update after transition
var pageSlug = 'case';
import DdButton from '~/components/DdButton.vue';
import PanelButton from '~/components/panels/PanelButton.vue';
import Stats from '~/components/reactions/Stats.vue';
import Like from '~/components/reactions/Like.vue';
import WebpPicture from '~/components/WebpPicture.vue';
import Case from '~/components/thumbnails/Case.vue';
import SideScroll from '~/components/SideScroll.vue';
import BackButton from '~/components/BackButton.vue';
import NavigationBar from '~/components/navigation/NavigationBar.vue';
import ShareButton from '~/components/share/ShareButton.vue';
export default {
  components: {
    TextModule: function TextModule() {
      return import('~/components/case/TextModuleNew.vue');
    },
    EmbedModule: function EmbedModule() {
      return import('~/components/case/EmbedModuleNew.vue');
    },
    ImageModule: function ImageModule() {
      return import('~/components/case/ImageModuleNew.vue');
    },
    PanelButton: PanelButton,
    DdButton: DdButton,
    Stats: Stats,
    Like: Like,
    WebpPicture: WebpPicture,
    Case: Case,
    SideScroll: SideScroll,
    BackButton: BackButton,
    NavigationBar: NavigationBar,
    ShareButton: ShareButton,
    Panel: function Panel() {
      return import('~/components/panels/CasesPanel.vue');
    },
    Comments: function Comments() {
      return import('~/components/comments/Comments.vue');
    },
    Dropdown: function Dropdown() {
      return import('~/components/CasesDropdown.vue');
    },
    Follow: function Follow() {
      return import('~/components/profile/Follow.vue');
    },
    MaterialGallery: function MaterialGallery() {
      return import('~/components/overlays/MaterialGallery.vue');
    },
    Overlay: function Overlay() {
      return import('~/components/overlays/Overlay.vue');
    },
    Share: function Share() {
      return import('~/components/share/ShareDropdown.vue');
    }
  },
  head: function head() {
    var title = this.post.metaTitle || "".concat(this.$t('general.article'), " \xAB").concat(this.post.title, "\xBB");
    var desc = this.post.metaDescription || this.post.description;
    var url = "".concat(process.env.baseUrl, "/").concat(this.$route.path);
    var image = this.post.thumbnail ? "".concat(this.$CDN, "/image/medium/").concat(this.post.thumbnail.name) : '';
    var meta = [{
      hid: 'title',
      name: "title",
      content: title
    }, {
      hid: "og:url",
      property: "og:url",
      content: url
    }, {
      hid: "og:title",
      property: "og:title",
      content: title
    }, {
      hid: "og:image",
      property: "og:image",
      content: image
    }, {
      hid: "twitter:url",
      name: "twitter:url",
      content: url
    }, {
      hid: "twitter:title",
      name: "twitter:title",
      content: title
    }, {
      hid: "twitter:image",
      name: "twitter:image",
      content: image
    }];
    if (desc) {
      meta.push({
        hid: 'description',
        name: 'description',
        content: desc
      });
      meta.push({
        hid: "og:description",
        property: "og:description",
        content: desc
      });
      meta.push({
        hid: "twitter:description",
        name: "twitter:description",
        content: desc
      });
    }
    var structuredData = {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": this.post.title,
      "datePublished": this.post.createdAt,
      // "dateModified": this.article.updatedAt,
      "mainEntityOfPage": "https://cases.media/".concat(pageSlug, "/").concat(this.post.slug || this.post.id)
    };
    if (this.post.thumbnail) {
      // Prevent errors when no thumbnail is set on draft pages

      structuredData.image = ["".concat(this.$CDN, "/image/small/").concat(this.post.thumbnail.name), "".concat(this.$CDN, "/image/medium/").concat(this.post.thumbnail.name), "".concat(this.$CDN, "/image/wide/").concat(this.post.thumbnail.name)];
    }
    structuredData.author = [];
    this.perfomers.forEach(function (perfomer) {
      if (perfomer.id) {
        structuredData.author.push({
          "@type": "Organization",
          "name": perfomer.name,
          "url": "https://cases.media/".concat(perfomer.slug),
          "logo": "https://cases.media".concat(perfomer.img)
        });
      }
    });
    var link = [];
    if (this.post.headerImage && this.post.headerImage.name) {
      link.push({
        rel: "preload",
        href: "".concat(this.$CDN, "/image/wide/").concat(this.post.headerImage.name, ".webp"),
        as: "image",
        type: "image/webp"
      });
    }
    if (this.post.version) {
      for (var code in this.post.version) {
        link.push({
          rel: "alternate",
          href: this.localePath("/".concat(pageSlug, "/").concat(this.post.version[code].slug), code),
          hreflang: code
        });
      }
    }
    return {
      title: title,
      meta: meta,
      script: [{
        type: 'application/ld+json',
        json: structuredData
      }],
      link: link,
      bodyAttrs: {
        class: 'gray-page'
      }
    };
  },
  data: function data() {
    return {
      post: {},
      tags: [],
      newComment: false,
      creditsVisible: true,
      creditsPlacement: 'bottom',
      creditsAnchorId: 'case-credits',
      reactions: false,
      moreByAuthor: [],
      currentImageIndex: 0
    };
  },
  asyncData: function asyncData(_ref) {
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var $axios, route, error, redirect, app, $appStore, id, preview, data, post, moreByAuthor, result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            $axios = _ref.$axios, route = _ref.route, error = _ref.error, redirect = _ref.redirect, app = _ref.app, $appStore = _ref.$appStore;
            $appStore.$patch({
              activeApp: 'media'
            });
            id = route.params.slug;
            preview = route.params.preview;
            _context.next = 6;
            return $axios.$get("".concat($axios.defaults.baseURL, "/publication/get"), {
              params: {
                id: id,
                preview: preview,
                comments: true
              }
            }).catch(function (e) {
              error({
                statusCode: 404,
                message: app.i18n.t('page.article.404')
              });
            });
          case 6:
            data = _context.sent;
            post = data && data.post;
            moreByAuthor = data && data.moreByAuthor;
            if (post) {
              _context.next = 11;
              break;
            }
            return _context.abrupt("return", error({
              statusCode: 404,
              message: app.i18n.t('page.article.404')
            }));
          case 11:
            if (!(!preview && post && post.slug && post.slug != id && !post.isTemp)) {
              _context.next = 13;
              break;
            }
            return _context.abrupt("return", redirect(app.localePath("/".concat(pageSlug, "/").concat(post.slug))));
          case 13:
            if (data.post.pubDate) data.post.pubDate = new Date(data.post.pubDate);
            result = {
              post: post,
              moreByAuthor: moreByAuthor
            };
            return _context.abrupt("return", result);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  computed: {
    locale: function locale() {
      return this.$i18n.locale || 'uk';
    },
    dropdownPlacement: function dropdownPlacement() {
      return ['lg', 'xl', 'xxl'].includes(this.$mq) ? 'left-start' : 'bottom-end';
    },
    clients: function clients() {
      var arr = [];
      this.post.clients.forEach(function (item) {
        arr.push(item.profile);
        if (item.team) arr.push.apply(arr, _toConsumableArray(item.team));
      });
      return arr;
    },
    perfomers: function perfomers() {
      var arr = [];
      this.post.perfomers.forEach(function (item) {
        arr.push(item.profile);
        if (item.team) arr.push.apply(arr, _toConsumableArray(item.team));
      });
      return arr;
    },
    isSingleAuthorPic: function isSingleAuthorPic() {
      var count = this.post.companies.length + this.post.users.length;
      return count <= 1;
    },
    isSingleAuthor: function isSingleAuthor() {
      var count = this.post.perfomers.length + this.post.clients.length;
      return count <= 1;
    },
    firstClient: function firstClient() {
      return this.post.clients && this.post.clients.length > 0 && this.post.clients[0].profile;
    },
    firstPerfomer: function firstPerfomer() {
      return this.post.perfomers && this.post.perfomers.length > 0 && this.post.perfomers[0].profile;
    },
    clientsTree: function clientsTree() {
      var arr = [];
      this.post.clients.forEach(function (item) {
        var block = [item.profile];
        if (item.team) block.push.apply(block, _toConsumableArray(item.team));
        arr.push(block);
      });
      return arr;
    },
    perfomersTree: function perfomersTree() {
      var arr = [];
      this.post.perfomers.forEach(function (item) {
        var block = [item.profile];
        if (item.team) block.push.apply(block, _toConsumableArray(item.team));
        arr.push(block);
      });
      return arr;
    },
    hasHeader: function hasHeader() {
      return this.post.headerType == 'header' && this.post.headerImage && this.post.headerImage.name;
    },
    headerImageType: function headerImageType() {
      if (!this.hasHeader || !this.post.headerImage.name) return null;
      var split = this.post.headerImage.name.split('.');
      var ext = split[split.length - 1].toLowerCase();
      if (ext == 'jpg') ext = 'jpeg';
      return "image/".concat(ext);
    },
    canEdit: function canEdit() {
      var _this = this;
      if (!this.$auth.user) return false;
      if (this.$auth.user.role.fullAccess) return true;
      if (this.post.company) {
        return this.$auth.user.moders && this.$auth.user.moders.some(function (o) {
          return o.approved && o.company.id == _this.post.company.id;
        });
      }
      return this.post.author.id == this.$auth.user.id;
    },
    canCreate: function canCreate() {
      return this.$auth.user && this.$auth.user.role.name.en !== 'Newbie';
    },
    isLastImage: function isLastImage() {
      return this.currentImageIndex >= this.images.length - 1;
    },
    isFirstImage: function isFirstImage() {
      return this.currentImageIndex <= 0;
    },
    images: function images() {
      if (!this.post.modules) return [];
      var images = this.post.modules.filter(function (module) {
        return module.type == 'image-module';
      });
      return images.map(function (module) {
        if (!module.src) return {
          name: '/images/c-placeholder-full.png'
        };
        var filePath = module.src.split('/');
        return {
          name: filePath[filePath.length - 1]
        };
      });
    },
    author: function author() {
      return this.post.company || this.post.author;
    },
    usersListStore: function usersListStore() {
      return useUsersListStore();
    }
  },
  mounted: function mounted() {
    this.$socket.on('connect', this.connect);
    this.$socket.on('update', this.update);
    this.observe();
    this.connect();
    var text = this.$t('toast.previewText');
    if (this.post.company) {
      text = this.$t('toast.previewTextModer', {
        name: this.post.company.name
      });
    }
    if (this.post.status !== 'published') {
      this.$toastStore.add({
        id: "preview-".concat(this.post.id),
        title: this.$t('toast.previewTitle'),
        text: text,
        icon: 'icon-ic-eye',
        autoClose: false
      });
    }
  },
  methods: {
    connect: function connect() {
      this.$socket.get("/user/joinRoom/", {
        roomName: "publication-".concat(this.post.id)
      });
    },
    disconnect: function disconnect() {
      this.$socket.get("/user/leaveRoom/", {
        roomName: "publication-".concat(this.post.id)
      });
    },
    update: function update(data) {
      if (data.id != this.post.id || data.model != 'publication') return true;
      if (typeof data.likes !== 'undefined') this.$set(this.post, 'likes', data.likes);
      if (data.views) this.$set(this.post, 'views', data.views);
      if (typeof data.commentsLength != 'undefined') {
        this.$set(this.post, 'commentsLength', data.commentsLength);
      }
    },
    writeComment: function writeComment() {
      if (!this.$auth.user) {
        this.$modalityStore.openModal({
          type: 'drawer',
          name: 'login',
          message: 'login.401.default'
        });
        return;
      }
      this.$refs.comments.write();
    },
    openGallery: function openGallery(event) {
      if (!event.target || !event.target.src) return;
      var filePath = event.target.src.split('/');
      var imageName = filePath[filePath.length - 1];
      var index = this.images.findIndex(function (image) {
        return image.name == imageName;
      });
      if (index < 0) return;
      this.currentImageIndex = index;
      this.$modalityStore.openModal({
        type: 'overlay',
        name: 'case-gallery'
      });
      event.target.blur();
      document.getElementById('main-app').click();
    },
    observe: function observe() {
      var _this2 = this;
      // Scroll to top observer
      var scrollTopThreshold = 0.3;
      this.perfomersObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var visible = entry.isIntersecting && entry.intersectionRatio >= scrollTopThreshold;
          _this2.creditsVisible = visible;
        });
      }, {
        root: null,
        rootMargin: '0px',
        threshold: scrollTopThreshold
      });
      var creditsBlock = document.querySelector('#case-top');
      if (creditsBlock) this.perfomersObserver.observe(creditsBlock);
    },
    unobserve: function unobserve() {
      if (this.perfomersObserver) this.perfomersObserver.disconnect();
    },
    hide: function hide() {
      var _this3 = this;
      var title = this.post.title || this.$t('general.untitled');
      if (!window.confirm(this.$t('case.confirmHide', {
        title: title
      }))) return;
      this.$axios.post("/publication/draft/".concat(this.post.id)).then(function (res) {
        _this3.$emit('hidden');
      }).catch(function (err) {
        console.log(err);
        _this3.$toastStore.add({
          title: _this3.$t('case.hideErrorTitle'),
          text: _this3.$t('case.hideErrorText'),
          icon: 'icon-ic-dismiss'
        });
      });
      this.$router.push({
        path: this.localePath("/".concat(this.author.slug, "/portfolio"))
      });
    },
    remove: function remove() {
      var _this4 = this;
      var title = this.post.title || this.$t('general.untitled');
      if (!window.confirm(this.$t('case.confirmDelete', {
        title: title
      }))) return;
      this.$axios.post("/publication/destroy/".concat(this.post.id)).then(function (res) {
        _this4.$emit('removed');
      }).catch(function (err) {
        console.log(err);
        _this4.$toastStore.add({
          title: _this4.$t('case.deleteErrorTitle'),
          text: _this4.$t('case.deleteErrorText'),
          icon: 'icon-ic-dismiss'
        });
      });
      this.$router.push({
        path: this.localePath("/".concat(this.author.slug, "/portfolio"))
      });
    },
    next: function next() {
      if (typeof this.currentImageIndex == 'undefined') return this.currentImageIndex = 0;
      if (this.currentImageIndex >= this.images.length - 1) {
        return this.currentImageIndex = this.images.length - 1;
      }
      document.getElementById('cases-overlay').scrollTop = 0;
      this.currentImageIndex++;
    },
    prev: function prev() {
      if (typeof this.currentImageIndex == 'undefined') return this.currentImageIndex = 0;
      if (this.currentImageIndex <= 0) return this.currentImageIndex = 0;
      document.getElementById('cases-overlay').scrollTop = 0;
      this.currentImageIndex--;
    },
    toggleCredits: function toggleCredits(placement, anchor) {
      this.updateCreditsPlacement(placement, anchor);
      this.$modalityStore.toggleDropdown({
        name: 'case-credits'
      });
    },
    showCredits: function showCredits(placement, anchor) {
      // Use toggle for mobiles only
      if (this.$mq == 'xs') return;
      this.closing = false;
      this.updateCreditsPlacement(placement, anchor);
      this.$modalityStore.openDropdown({
        name: 'case-credits'
      });
    },
    hideCredits: function hideCredits() {
      var _this5 = this;
      // Use toggle for mobiles only
      if (this.$mq == 'xs') return;
      this.closing = true;
      setTimeout(function () {
        if (_this5.closing) {
          _this5.$modalityStore.closeDropdown({
            name: 'case-credits'
          });
        }
      }, 300);
    },
    updateCreditsPlacement: function updateCreditsPlacement(placement, anchor) {
      if (placement) this.creditsPlacement = placement;
      if (anchor) this.creditsAnchorId = anchor;
    },
    showLikes: function showLikes() {
      this.usersListStore.update({
        id: "likes-".concat(this.post.id),
        url: '/user/getlikes',
        title: 'likes',
        params: {
          model: 'publication',
          id: this.post.id
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (process.browser) {
      this.unobserve();
      this.disconnect();
    }
  },
  destroyed: function destroyed() {
    this.$socket.off("update", this.update);
    this.$socket.off("connect", this.connect);
    this.$toastStore.remove("preview-".concat(this.post.id));
  }
};